const data = [
  {
    id: 1,
    avatar: "avatar-anisha",
    name: "Anisha Li",
    testimonial:
      "“Manage has supercharged our team’s workflow. The ability to maintain visibility on larger milestones at all times keeps everyone motivated.”",
  },
  {
    id: 2,
    avatar: "avatar-ali",
    name: "Ali Bravo",
    testimonial:
      "“We have been able to cancel so many other subscriptions since using Manage. There is no more cross-channel confusion and everyone is much more focused.”",
  },
  {
    id: 3,
    avatar: "avatar-richard",
    name: "Richard Watts",
    testimonial:
      "“Manage allows us to provide structure and process. It keeps us organized and focused. I can’t stop recommending them to everyone I talk to!”",
  },
  {
    id: 4,
    avatar: "avatar-shanai",
    name: "Shanai Gough",
    testimonial:
      "“Their software allows us to track, manage and collaborate on our projects from anywhere. It keeps the whole team in-sync without being intrusive.”",
  },
];

export default data;
